import React, {useState} from "react";
import product from "../../assets/img/detailproduct.png";
import PopupLoginError from "../Popup/LoginError";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../hooks/useLanguage";

function OrderItem({ item, onSelect, onQuantityChange, onDelete, orderSummary, openInNewWindow }){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [productCount, setProductCount] = useState(item?.ea || 1);
  const [isPopupLoginError, setIsPopupLoginError] = useState('');

  // 카운트버튼
  const handleCount = (type) => {
    // 체크되지 않은 상태라면 수량 변경 불가
    if (!item.isChecked) {
      setIsPopupLoginError('상품을 먼저 선택해주세요.');
      return;
    }
    
    // 문자열을 숫자로 명시적 변환 (parseInt)
    let newCount = parseInt(productCount, 10);
    
    if (type === 'plus') {
      newCount = newCount + 1; 
    } else {
      newCount = Math.max(1, newCount - 1); // 최소 1개 이상
    }
    
    setProductCount(newCount);
    
    // API 호출 로직
    const changeData = {
      cart_option_seq: item?.cart_option_seq,
      ea: newCount,
      delete_flag: 'N'
    };
    onQuantityChange?.(changeData);
  }

  // 삭제 버튼 핸들러
  const handleDelete = () => {
    if (!item?.cart_option_seq) return;
    
    const deleteData = {
      cart_option_seq: item?.cart_option_seq,
      ea: item?.ea,
      delete_flag: 'Y'
    };
    onDelete?.(deleteData);

      // 삭제 요청 후 0.5초 후에 새로고침 실행
    // setTimeout(() => {
    //   window.location.reload();
    // }, 500);

  };

  // 체크박스 변경 핸들러
  // const handleCheckboxChange = (e) => {
  //   onSelect?.(item.cart_option_seq, e.target.checked);
  // };

    // 상세페이지 이동
    const handleorderDetail = (goods_seq) => {
      if (openInNewWindow) {
        // 70% 새창으로 열기
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const windowWidth = Math.floor(screenWidth * 0.7);
        const windowHeight = Math.floor(screenHeight * 0.7);
        const left = Math.floor((screenWidth - windowWidth) / 2);
        const top = Math.floor((screenHeight - windowHeight) / 2);
        
        window.open(
          `/product/detail/${goods_seq}`,
          '_blank',
          `width=${windowWidth},height=${windowHeight},left=${left},top=${top},resizable=yes,scrollbars=yes`
        );
      } else {
        // 기본 동작 (페이지 이동)
        navigate(`/product/detail/${goods_seq}`);
      }
    }


  return (
    <div className="order_item default_prod">
      <div className="default_chk_box">
        <input 
          type="checkbox" 
          id={`goods_${item?.cart_option_seq}`}
          checked={item?.isChecked || false}
          onChange={(e) => onSelect?.(item.cart_option_seq, e.target.checked)}
        />
        <label htmlFor={`goods_${item?.cart_option_seq}`} />
      </div>
      <div className="prod_container">
        <img
          src={item?.goods_image || product}
          alt="상품 이미지"
          className="order_prod_img"
          onClick={()=> handleorderDetail(item.goods_seq)}
        />
        <div className="prod_info">
          <div className="info_box">
            <div className="prod_title">
              <p className="title ellipsis1">{item?.product_name || '제목 없음'}</p>
              {item?.type === 'bundleMain' && (
                <p className="sub_title ellipsis1">{item?.description_kr_01}</p>
              )}
              {orderSummary !== 'sale' && item?.package_name && item?.package_name !== '' && (
                <p className="option_count desktop-only">
                  {t('package')}: {item?.package_name}
                </p>
              )}
              {orderSummary === 'sale' && (
                <>
                  {item?.option1 && item?.option2 && item?.option3 && (
                    <p className="option_count">
                      {t('option')}: {item?.option1}, {item?.option2}, {item?.option3}
                    </p>
                  )}
                  {item?.option1 && item?.option2 && !item?.option3 && (
                    <p className="option_count">
                      {t('option')}: {item?.option1}, {item?.option2}
                    </p>
                  )}
                  {item?.option1 && !item?.option2 && !item?.option3 && (
                    <p className="option_count">
                      {t('option')}: {item?.option1}
                    </p>
                  )}
                </>
              )}

            </div>

              <div className="insurance_box">
                {orderSummary !== 'sale' && item?.insurance_flag === 'N' && (
                  <p>보험 미가입상품</p>
                )}
              </div>

            <div className="price">
              {orderSummary === 'sale' ? (
                <p>₩<span>{item?.price?.toLocaleString()}</span></p>
              ) : (
                <p>₩<span>{item?.unit_rental_12_price?.toLocaleString()}</span> / ₩<span>{item?.unit_rental_24_price?.toLocaleString()}</span></p>

              )}
            </div>
          </div>
          <div className="prod_count_box">
            <div className="count_btn_box">
              <button
                type="button"
                className="minus_btn"
                onClick={() => handleCount('')}
                disabled={!item.isChecked}
              />
              <input
                type="number"
                value={productCount}
                readOnly
                style={{ opacity: item.isChecked ? 1 : 0.5 }}
              />
              <button
                type="button"
                className="plus_btn"
                onClick={() => handleCount('plus')}
                disabled={!item.isChecked}
              />
            </div>
            {item?.stock_flag === 'N' && (  // 재고부족
              <div className="stock_btn">
                <span className="mobile-text">{t('stock_shortage')}</span>
              </div>
            )}
          </div>
          <div className="total_price">
            <p>
              <span className="won">₩</span>
              <span className="order_amount">
                {item?.sum_sale_price?.toLocaleString()}
              </span>
            </p>
            <button 
              type="button" 
              className="delete_btn"
              onClick={handleDelete}
            />
          </div>
        </div>
      </div>
        <PopupLoginError
          isPopup={isPopupLoginError}
          setIsPopup={setIsPopupLoginError}
          // onConfirm={handleConfirm}/>
          />
    </div>


    //   그외 나머지(견적서, 마이페이지)는 아래꺼 사용 
    // 클래스 'sub_title' , 'option_count'  > '대여상품 정보'  / '부가품목' / '액세서리' 분기 주의 

    //  <div className="order_item default_prod"></div>
    //     <div className="prod_container">
    //       <img
    //         src={product}
    //         alt="상품 이미지"
    //         className="order_prod_img"
    //       />
    //       <div className="prod_info">
    //         <div className="info_box">
    //           <div className="prod_title">
    //             <p className="title ellipsis1">ARRI ALEXA Mini Full</p>

    //             <p className="sub_title ellipsis1">PL Mountd PL Mountd PL Mountd</p>

    //             <p className="option_count">
    //               패키지: ARRI ALEXA Mini, PL Mountd, PL Mountd,ARRI ALEXA Mini, PL Mountd, ARRI ALEXA Mini, PL Mountd,ARRI ALEXA Mini 
    //               / 수량<span className="quo_count"> :1개</span></p>
    //             <p className="strong_b3" style={{marginTop:'8px'}}>₩<span className="strong_b1"></span>200,000</p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    
    // </div>
  )
};

export default OrderItem;